export const FEATURE_LEGAL_SUPPORT = 'legal-support';
export const FEATURE_CALL_AND_CHECK = 'call-and-check';
export const FEATURE_BRANDING_CONTRACTS = 'branding-contracts';
export const hasFeature = (featureName) => ({ id }) => featureName === id;
